<template>
  <ul class="table__row">
    <li class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
    <li class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
    <li class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
    <li class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
    <li class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
    <li class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
    <li class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
    <li class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
    <li class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
    <li v-if="permissionsUpdate" class="table__col">
      <p class="ajax__line ajax__line-table-text"></p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    permissionsUpdate: {}
  }
};
</script>
